import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class GridHelper extends Component {
    _enabled = localStorage.getItem('grid-helper') === 'true';
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        this._enabled = value;
        this.el.classList.toggle('visible', value);
    }
    initialized() {
        this.enabled = this._enabled;
        super.initialized();
    }
    bindEvents(add) {
        const method = bindMethod(add);
        window[method]('keydown', (e) => this.handleKeyDown(e));
    }
    handleKeyDown(event) {
        if (event.code === 'KeyG' && event.altKey) {
            this.enabled = !this.enabled;
            localStorage.setItem('grid-helper', this.enabled.toString());
        }
    }
}
